var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcnValue1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 86.267,
    height: 86.936,
    viewBox: "0 0 86.267 86.936",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icn-value1",
    transform: "translate(-360 -4152)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2274",
    "data-name": "Groupe 2274",
    transform: "translate(360 4152)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_251",
    "data-name": "Rectangle 251",
    width: 86.267,
    height: 86.936,
    rx: 20,
    fill: "rgba(255,186,70,0.17)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2417",
    "data-name": "Groupe 2417",
    transform: "translate(320.332 4108.646)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2318",
    "data-name": "Trac\\xE9 2318",
    d: "M58,191.627a1.785,1.785,0,0,1,1.981-1.086c.337.032.679.005,1.066.005v-.622q0-6.191,0-12.382c0-1.184.55-1.7,1.741-1.753,1.782-.076,3.564-.187,5.344-.308a1.484,1.484,0,0,1,1.761,1.6q.005,6.412,0,12.824v.611h2.949v-.592q0-6.854,0-13.708a1.582,1.582,0,0,1,1.41-1.8q2.6-.722,5.174-1.523c1.4-.439,2.262.152,2.263,1.617q0,7.689,0,15.379v.624H84.64v-.565c0-5.978.008-11.956-.009-17.934a1.85,1.85,0,0,1,1.077-1.8c1.775-.98,3.52-2.014,5.259-3.057a1.629,1.629,0,0,1,1.747-.2,1.593,1.593,0,0,1,.779,1.576q-.012,10.687,0,21.373v.615h2.949v-.584q0-12.972-.009-25.943a2.242,2.242,0,0,1,.733-1.678c1.813-1.865,3.586-3.771,5.359-5.676a1.722,1.722,0,0,1,1.24-.694,1.459,1.459,0,0,1,1.517,1.363c.015.179.007.36.007.54q0,15.993,0,31.986v.718H106.6a1.529,1.529,0,0,1,1.7,1.168,1.5,1.5,0,0,1-.99,1.708c-.025.013-.038.048-.057.072H59.081A2.265,2.265,0,0,1,58,192.413Z",
    transform: "translate(0 -84.496)",
    fill: "#ffaa1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2319",
    "data-name": "Trac\\xE9 2319",
    d: "M58,85.8c.468-.954,1.236-1.1,2.24-1.025a44.5,44.5,0,0,0,24.141-5.026A46.435,46.435,0,0,0,98.129,68.726c1.969-2.28,3.991-4.516,5.988-6.772.072-.081.136-.168.264-.328-1.127,0-2.168,0-3.208,0a2.33,2.33,0,0,1-.675-.088,1.457,1.457,0,0,1,.339-2.842q3.071-.038,6.142,0a1.307,1.307,0,0,1,1.269,1.314c.04,2.013.069,4.027.075,6.041a1.457,1.457,0,0,1-1.466,1.472,1.48,1.48,0,0,1-1.473-1.47c-.011-.307,0-.614,0-1.064-.251.277-.419.46-.586.646-2.194,2.453-4.317,4.975-6.6,7.347a47.791,47.791,0,0,1-24.376,13.7,46.288,46.288,0,0,1-14.3,1.019A1.76,1.76,0,0,1,58,86.59Z",
    fill: "#ffaa1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2320",
    "data-name": "Trac\\xE9 2320",
    d: "M58,433.765a2.265,2.265,0,0,0,1.081,1.081H58Z",
    transform: "translate(0 -325.848)",
    fill: "#ffaa1c"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnValue1);
export default __webpack_public_path__ + "static/media/icn-value1.96a135a838f58749988cb134c556c602.svg";
export { ForwardRef as ReactComponent };